import { render, staticRenderFns } from "./user_locales.vue?vue&type=template&id=9a57cb6e&scoped=true&"
import script from "./user_locales.vue?vue&type=script&lang=js&"
export * from "./user_locales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a57cb6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a57cb6e')) {
      api.createRecord('9a57cb6e', component.options)
    } else {
      api.reload('9a57cb6e', component.options)
    }
    module.hot.accept("./user_locales.vue?vue&type=template&id=9a57cb6e&scoped=true&", function () {
      api.rerender('9a57cb6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/tabs/user_locales.vue"
export default component.exports